import "../../css/Map.css";
import { Status, Wrapper } from "@googlemaps/react-wrapper";
import MapDesc from "./MapDesc";

const Map = () => {
  const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  //レンダリング中のステータス表示
  const render = (status: Status) => <h1>{status}</h1>;

  return (
    <div className="map_container">
      <Wrapper apiKey={API_KEY!} render={render}>
        <MapDesc></MapDesc>
      </Wrapper>
    </div>
  );
};

export default Map;
